// src/helpers/settings/modals/additionModal.ts
var getSettingsMainScreenDataCore = (entity, state) => {
  const currentSettings = state.settings.location;
  const masterSettings = state.settings.master;
  const masterEntityIds = Object.keys(masterSettings[entity]);
  const currentSettingsEntityIds = Object.keys(currentSettings[entity]);
  const difference = masterEntityIds.filter(
    (id) => currentSettingsEntityIds.indexOf(id) === -1
  );
  return difference;
};

export { getSettingsMainScreenDataCore };
